import { STEPS } from './OnboardingHandler.enum';

export function sentToZenviaOnSuccess({
  currentStep,
  usingTempDomain,
  sentToZenvia,
  flowCreateSiteTemporaryDomain,
  currentHosting,
  createdTemporaryDomain,
  triggerSiteCreatedWithTempDomain,
  setsentToZenvia,
}) {
  if (currentStep === STEPS.SUCCESS && usingTempDomain && !sentToZenvia && flowCreateSiteTemporaryDomain) {
    triggerSiteCreatedWithTempDomain({
      hostingId: currentHosting ? currentHosting.hosting_id : null,
      domain: currentHosting ? currentHosting.domain : createdTemporaryDomain,
    });
    setsentToZenvia(true);
  }
}
